// Module
var code = `<svg class="symbol" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet"><circle cx="50" cy="50" r="50%"/></svg>`;
// Exports
export default code;